class AppearanceEffect {
    constructor() {
        this.threshold = 100;
        this.offsetCorrent = 100;
        this.inRowTimeout = 200;
        this.animate = false;
        
        this.updateElements();
        this.onProcess();
        this.onProcessHandler = this.onProcess.bind(this);
        // window.addEventListener('scroll', this.onProcess.bind(this));
        // window.addEventListener('resize', this.onProcess.bind(this));

        themeBase.onDOMContentLoadedTrigger(() => {
            this.onProcess();
            window.addEventListener('MutationObserverLoaded', this.onMutationObserver.bind(this));
            window.addEventListener('scroll', () => this.animate = true, {once: true});

            ['resize', 'scroll']
                .forEach(event => window.addEventListener(event, () => {
                    const animationStep = () => {
                        this.onProcessHandler();
                    };
            
                    this.requestAnimation = window.requestAnimationFrame(animationStep);
                }));
        });
    }

    updateElements() {
        this.elements = document.querySelectorAll('.animated-appearance:not(.animated-appearance--caught)');
    }

    onMutationObserver() {
        this.updateElements();
        this.onProcess();
    }

    onProcess() {
        const caughtElements = [];

        this.elements.forEach(element => {
            if(element.classList.contains('animated-appearance--caught')) return;
            
            const elementBound = element.getBoundingClientRect();
            const elementDataThreshold = element.dataset.appearanceThreshold;
            const threshold = elementDataThreshold !== undefined ? elementDataThreshold : this.threshold;
            const crossedViewport = elementBound.top - this.offsetCorrent < window.innerHeight - threshold;

            if(crossedViewport && (!this.animate || !themeBase.pageLoaded)) {
                element.classList.add('animated-appearance--caught');
                element.classList.remove('animated-appearance');
            } else if (crossedViewport && elementBound.bottom - this.offsetCorrent > 0) {
                element.classList.add('animated-appearance--animate', 'animated-appearance--caught');
                caughtElements.push(element);
            } else {
                element.classList.add('animated-appearance--deferred');
            }
        });
        caughtElements.forEach((element, index) => {
            const inRowTimeout = this.inRowTimeout * index;

            setTimeout(() => element.classList.add('animated-appearance--visible'), inRowTimeout);
        });
    }

    cleanHTMLWithEffect(html) {
        return html.replace(/animated-appearance/gs, '');
    }
}

window.appearanceEffect = new AppearanceEffect;